/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { Box, MenuItem, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { ToastContainer, Zoom, toast } from "react-toastify";

const data = [
  { sl: 101, Menu_name: "Dashboard", active_status: true },
  { sl: 102, Menu_name: "Security", active_status: false },
  { sl: 103, Menu_name: "Setup", active_status: true },
  { sl: 104, Menu_name: "Volunteer Bank", active_status: true },
  { sl: 105, Menu_name: "Study Compliance", active_status: false },
];

const EditSubmenu = ({ moduleInfo, subRefetch }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const submenuData = useSelector((state) => state.Modal.val);
  // console.log("submenuData", submenuData);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  const onSubmit = (data, e) => {
    alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("sa_module_id", data.sa_module_id);
    formData.append("sa_mlink_name", data.sa_mlink_name);
    formData.append("url_uri", data.url_uri);
    formData.append("active_fg", data.active_fg);

    // http://192.168.0.173/kyamch_ctms_backend_qa/api/updateModuleLinkSetup/9
    fetch(
      `${process.env.REACT_APP_API_URL}/api/updateModuleLinkSetup/${submenuData.sa_mlinks_id}`,
      {
        method: "POST",
        body: formData,
        // headers: {
        //   accept: "application/json",
        //   "content-type": "application/json",
        // },

        // body: JSON.stringify(data),
      }
    )
      .then((res) => {
        // console.log("res", res);
        return res.json();
      })
      .then((data) => {
        // console.log("data", data);
        if (data.success === true) {
          reset();
          dispatch(handleEditClose());
          subRefetch();
        } else if (data.duplicate === true) {
          toast.error("Module is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  const filteredData = moduleInfo.filter((obj) => obj.active_fg === "Y");
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <Box mb="20px">
          <TextField
            select
            defaultValue={submenuData?.sa_module_id}
            fullWidth
            size="small"
            label="Module Name*"
            {...register("sa_module_id", {
              required: true,
            })}
          >
            {filteredData?.map((menu) => (
              <MenuItem
                key={Math.random()}
                // key={sponsor.sponsor_id}
                value={menu.module_id}
              >
                {menu.module_name}
              </MenuItem>
            ))}
          </TextField>
          {errors?.sa_module_id?.type === "required" && (
            <ErrorMessage>Module name is required</ErrorMessage>
          )}
        </Box>

        <Box mb="20px">
          <TextField
            defaultValue={submenuData?.sa_mlink_name}
            size="small"
            fullWidth
            label="Submenu Name*"
            variant="outlined"
            {...register("sa_mlink_name", { required: true })}
          />
          {errors?.sa_mlink_name?.type === "required" && (
            <ErrorMessage>Submenu is required*</ErrorMessage>
          )}
        </Box>

        <Box mb="20px">
          <TextField
            defaultValue={submenuData?.url_uri}
            size="small"
            fullWidth
            label="Route Name*"
            variant="outlined"
            {...register("url_uri", { required: true })}
          />
          {errors?.url_uri?.type === "required" && (
            <ErrorMessage>Route name is required*</ErrorMessage>
          )}
        </Box>

        <Box>
          <TextField
            select
            defaultValue={submenuData?.active_fg}
            size="small"
            fullWidth
            label="Active Status"
            variant="outlined"
            {...register("active_fg", {
              // required: true
            })}
          >
            <MenuItem value="Y">Active</MenuItem>
            <MenuItem value="N">Inactive</MenuItem>
          </TextField>
          {errors?.active_status?.type === "required" && (
            <ErrorMessage>Active status is required*</ErrorMessage>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {/* {isLoading ? (
      <ThemButton
        style={
          {
  
          }
        }
        type="submit"
      >
        <SyncLoader color="#FFFFFF" size={8} />
      </ThemButton>
    ) : (
      <ThemButton
        style={
          {
          }
        }
        type="submit"
      >
        Update User Level
      </ThemButton>
    )}

    <ToastContainer
      autoClose={2000}
      limit={1}
      transition={Zoom}
      toastStyle={{ border: "2px solid crimson" }}
    /> */}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />

        <ThemButton style={{}} type="submit">
          Update
        </ThemButton>
      </Box>
    </form>
  );
};

export default EditSubmenu;
